import React, { useEffect, useState } from "react";
import ThemedBlock from "components/atoms/ThemedBlock";
import Button from "theme/Button";
import i18n from "utils/i18n";
import _ from "lodash";
import Ajax from "utils/request/ajax";
import Title from 'components/atoms/Title'
import Description from 'components/atoms/Description'
import HelperString from 'utils/helper-string'
import HelperAlerts from 'utils/HelperAlerts'
import ThemedRangeDatepicker from 'components/atoms/ThemedRangeDatepicker'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import Select from 'theme/Select'
import { configClient } from 'components/provider/ConfigProvider'
import { openUrl } from 'utils/helper-url'
import HelperDate, { dateFormat } from 'utils/helper-date'
import ThemedSelect from "components/atoms/ThemedSelect";
import HStack from "components/atoms/stack/HStack";
import VStack from "components/atoms/stack/VStack";

const ManagementReportsReportsOccupancy = ({ employee, report }) => {
	
	const _buildings         = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} );
	const _floors            = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} );
	const _rooms             = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} );
	const _timeslotKinds     = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const [ buildingOptions, setBuildingOptions ] = useState( [] );
	const [ timeslotOptions, setTimeslotOptions ] = useState( [] );

	const [ generating, setGenerating ] = useState( false )

	const [ selectedDate, setSelectedDate ] = useState( HelperDate.defaultDateRange() )
	const [ selectedBuildingIndex, setSelectedBuildingIndex ] = useState( null )
	const [ selectedBuilding, setSelectedBuilding ] = useState( null );
	const [ selectedTimeslotIndex, setSelectedTimeslotIndex ] = useState( null );
	const [ selectedTimeslot, setSelectedTimeslot ] = useState( null );

	const [ url, setUrl ] = useState( null )

	useEffect( () => {
		let newBuildingOptions = [];

		_.forEach( _buildings, ( building ) => {
			newBuildingOptions.push( {
				value: HelperString.random( 10 ),
				label: building.name,
				object: { building_guid: building.guid, floor_guid: null, room_guid: null },
			});

			_.forEach( _.get( building, 'floors', [] ), ( floor ) => {
				floor = _.find( _floors, { guid: floor.guid } );

				newBuildingOptions.push( {
					value: HelperString.random( 10 ),
					label: building.name + ' - ' + floor.name,
					object: { building_guid: building.guid, floor_guid: floor.guid, room_guid: null },
				});

				_.forEach( _.get( floor, 'rooms', [] ), ( room ) => {
					room = _.find( _rooms, { guid: room.guid } );

					newBuildingOptions.push({
						value: HelperString.random( 10 ),
						label: building.name + ' - ' + floor.name + ' - ' + room.name,
						object: { building_guid: building.guid, floor_guid: floor.guid, room_guid: room.guid },
					});
				});
			});
		});

		setBuildingOptions( newBuildingOptions );
	}, [ _buildings, _floors, _rooms ] );

	useEffect( () => {
		let newTimeslotOptions = [];
		_.forEach( _timeslotKinds, ( timeslotKind ) => {
			newTimeslotOptions.push( {
				value: HelperString.random( 10 ),
				label: timeslotKind?.name,
				object: {kind: timeslotKind?.kind, sub_kind: timeslotKind?.sub_kind},
			});
		});
		setTimeslotOptions( newTimeslotOptions );
	}, [ _timeslotKinds ] );

	useEffect( () => {
		// Find by value
		const selected = _.find( buildingOptions, { value: selectedBuildingIndex } );
		setSelectedBuilding( selected?.object || null );
		setUrl( null );
	}, [ selectedBuildingIndex ] );

	useEffect( () => {
		// Find by value
		const selected = _.find( timeslotOptions, { value: selectedTimeslotIndex } );
		setSelectedTimeslot( selected?.object || null );
		setUrl( null );
	}, [ selectedTimeslotIndex ] );

	const setSelectedMultiDate = ( selectedRange ) => {
		setSelectedDate( selectedRange )
		setUrl( null )
	}

	const onSelectBuilding = ( value ) => {
		setSelectedBuildingIndex( value )
	}

	const onSelectTimeslot = ( value ) => {
		setSelectedTimeslotIndex( value )
	}

	const generate = () => {
		if( generating ) {
			return;
		}

		// if we already generated the outcome don't do it again!!
		if( url !== null ) {
			openUrl( url );
			return;
		}

		if( selectedBuilding === null || selectedBuilding === undefined ){
			return;
		}

		if( selectedTimeslot === null || selectedTimeslot === undefined ){
			return;
		}

		const guid = _.get( employee, 'guid', '' );

		// When not set then we set it
		if( selectedDate[ 1 ] === null ) {
			selectedDate[ 1 ] = selectedDate[ 0 ]
		}

		// Create the variables
		let variables = {
			guid: guid,
			identifier: report.identifier,
			date: HelperDate.date(  selectedDate[ 0 ] ).format( dateFormat.DATE ),
			date_till: HelperDate.date( selectedDate[ 1 ] ).format( dateFormat.DATE ),
			building_guid: _.get( selectedBuilding, 'building_guid', '' ),
			floor_guid: _.get( selectedBuilding, 'floor_guid', '' ),
			room_guid: _.get( selectedBuilding, 'room_guid', '' ),
			kind: _.get( selectedTimeslot, 'sub_kind', '' ),
			sub_kind: _.get( selectedTimeslot, 'sub_kind', '' ),
		}

		Ajax.request( configClient.url() + '/connection/rest/management/generate_report_occupancy', {
			variables,
			onStart: () => {
				setGenerating( true )
			},
			onSuccess: ( result ) => {
				let url = null;

				switch( result.status ) {
					case 'success':
						url = result.url;
						openUrl( url );
						break;

					default:
						captureError( result.error );
						break;
				}

				setGenerating( false )
				setUrl( url )
			},
			onError: ( result ) => {
				setGenerating( false )
				setUrl( null )

				captureError( result.error );
			},
		});
	}

	const captureError = ( error ) => {
		switch( error ) {
			case 'no_output':
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.no_output') );
				break;

			case 'access_denied':
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.access_denied') );
				break;

			default:
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.something_went_wrong') );
				break;

		}
	}

	let identifier = report.identifier;

	let valid = true;
	if( selectedBuilding === null || selectedBuilding === undefined || selectedTimeslot === null || selectedTimeslot === undefined  ){
		valid = false
	}

	return (
		<ThemedBlock
			key={ HelperString.hash( 'ManagementReportsReportBySingleDate', report.identifier ) }
			mediumPadding
			shadow>

			<VStack>
				{ i18n.exists(`management:reports.${identifier}.title`) && (
					<Title>
						{i18n.t(`management:reports.${report.identifier}.title`)}
					</Title>
				)}

				{ i18n.exists(`management:reports.${identifier}.description`) && (
					<Description>
						{i18n.t(`management:reports.${report.identifier}.description`)}
					</Description>
				)}

				<HStack>
					<ThemedRangeDatepicker
						range={ selectedDate }
						onSelect={ setSelectedMultiDate }
					/>

					<ThemedSelect
						placeholder={ i18n.t('management:pages.occupancy.building_select' ) }
						select={ onSelectBuilding }
						selected={ selectedBuildingIndex }
						options={ buildingOptions }
					/>

					<ThemedSelect
						placeholder={ i18n.t('management:pages.occupancy.timeslot_kind_select' ) }
						select={ onSelectTimeslot }
						selected={ selectedTimeslotIndex }
						options={ timeslotOptions}
					/>
				</HStack>

				{ valid && (
					<Button
						onPress={ generate.bind( this ) }
						isLoading={ generating }
						size={"small"}>

						{ i18n.t('management:pages.reports.index.btn_download') }
					</Button>
				)}
			</VStack>
		</ThemedBlock>
	);
}

export default ManagementReportsReportsOccupancy
